/* Creamy Meadow app logic */

const GOAT_IMG = CMIMG[0];
const STAMP_IMG = CMIMG[1];
const SOAP_IMG = CMIMG[2];
const CHECKOUT_IMG = CMIMG[3];
/* ============ PAGE ROUTER ============ */
function showPage(p){
  if(p!=='product') quizMatch = null;   // banner only persists while on the matched product
  ['home','goats','quiz','about','shop','product','contact'].forEach(id=>{
    const el = document.getElementById('page-'+id);
    if(el) el.style.display = (id===p) ? 'block' : 'none';
  });
  if(p==='shop' && typeof renderShop==='function') renderShop();
  var _cn=document.getElementById('checkoutNote'); if(_cn) _cn.style.display='none';
  window.scrollTo(0,0);
  if(p==='home' && window.__resetRide) window.__resetRide();
  if(p!=='product'){ try{ if(typeof cmSyncUrl==='function') cmSyncUrl('/'); }catch(e){} }
}

/* ============ FAQ ACCORDION + INERT FORMS + SECTION JUMPS ============ */
function toggleFaq(btn){
  const item = btn.closest('.faq-item');
  const panel = item.querySelector('.faq-a');
  const open = item.classList.toggle('open');
  panel.style.maxHeight = open ? (panel.scrollHeight + 'px') : '0';
}
/* ====================================================================
   STOREFRONT CONFIG — fill these in when wiring the site to Shopify.
   (search the file for "STORE." to see exactly where each one is used)
   ==================================================================== */
var STORE = {
  // POST endpoint for newsletter + gift-popup emails. Paste the URL from
  // your email tool: Shopify Forms, Klaviyo, Mailchimp, Omnisend, Formspree…
  // Leave this blank when using Shopify's native customer capture.
  emailEndpoint: '',
  // Set true to capture newsletter + gift-popup emails into Shopify's free
  // Customers list via the native /contact endpoint (no app, no fee).
  shopifyForms: true,
  // Discount code shown in the gift popup. Create the SAME code in Shopify:
  // Discounts > Create discount > Amount off products > 5% off > code MEADOW5.
  discountCode: 'MEADOW5'
};

// Submit a newsletter/customer form through Shopify.
// Liquid's {% form 'customer' %} adds Shopify's required hidden fields.
function sendEmailLead(email, source, form){
  if(!email) return Promise.resolve(false);

  if(STORE.shopifyForms && form){
    try{
      var data = new FormData(form);
      data.set('contact[email]', email);
      data.set('contact[tags]', 'newsletter,' + (source || 'site'));

      return fetch(form.action || '/contact', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Accept': 'text/html' },
        body: data
      }).then(function(response){
        return response.ok;
      }).catch(function(){
        return false;
      });
    }catch(error){
      console.warn('[Creamy Meadow] Shopify email capture failed:', error);
    }
  }

  // Fallback for an optional external email provider.
  if(!STORE.emailEndpoint) return Promise.resolve(false);

  try{
    return fetch(STORE.emailEndpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: email, source: source || 'site' })
    }).then(function(response){
      return response.ok;
    }).catch(function(){
      return false;
    });
  }catch(error){
    return Promise.resolve(false);
  }
}

function cmShowLeadMessage(element, show){
  if(!element) return;
  element.style.display = show ? 'block' : 'none';
}

function cmMarkEmailCaptured(){
  try{
    localStorage.setItem('cm_email_captured', '1');
  }catch(error){}
}

// Newsletter signup: only show success after Shopify accepts the submission.
function subscribeNewsletter(event){
  event.preventDefault();

  var form = event.currentTarget || event.target;
  var input = form ? form.querySelector('input[type="email"]') : null;
  var button = form ? form.querySelector('button[type="submit"]') : null;
  var email = input ? input.value.trim() : '';
  var ok = document.getElementById('nlOk');
  var error = document.getElementById('nlErr');

  cmShowLeadMessage(ok, false);
  cmShowLeadMessage(error, false);

  if(!input || !input.checkValidity()){
    if(input) input.reportValidity();
    return false;
  }

  var oldText = button ? button.textContent : '';
  if(button){
    button.disabled = true;
    button.textContent = 'Signing up…';
  }

  sendEmailLead(email, 'homepage', form).then(function(saved){
    if(!saved) throw new Error('Shopify did not accept the email.');

    cmMarkEmailCaptured();
    cmShowLeadMessage(ok, true);
    if(form.reset) form.reset();

    // A successful footer signup means the visitor no longer needs the popup.
    var popup = document.getElementById('popup');
    if(popup) popup.classList.remove('open');
  }).catch(function(captureError){
    console.error('[Creamy Meadow] Newsletter signup failed:', captureError);
    cmShowLeadMessage(error, true);
  }).then(function(){
    if(button){
      button.disabled = false;
      button.textContent = oldText;
    }
  });

  return false;
}

function fakeSubmit(e, okId){
  e.preventDefault();
  const ok = document.getElementById(okId);
  if(ok) ok.classList.add('show');
  if(e.target && e.target.reset) e.target.reset();
  return false;
}
/* real contact-form submit -> Shopify's native /contact (emails your store sender address) */
function submitContact(e){
  e.preventDefault();
  var f = e.target;
  var name = (f.cname && f.cname.value || '').trim();
  var email = (f.cemail && f.cemail.value || '').trim();
  var msg = (f.cmessage && f.cmessage.value || '').trim();
  var ok = document.getElementById('ctOk');
  if(ok) ok.classList.add('show');                 // optimistic thank-you
  try{
    var body = 'form_type=contact&utf8=%E2%9C%93'
      + '&contact[name]=' + encodeURIComponent(name)
      + '&contact[email]=' + encodeURIComponent(email)
      + '&contact[body]=' + encodeURIComponent(msg);
    fetch('/contact#contact_form', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: body
    }).catch(function(){});
  }catch(err){}
  if(f.reset) f.reset();
  return false;
}
function goHomeThenScroll(sel){
  showPage('home');
  setTimeout(function(){
    const el = document.querySelector(sel);
    if(el) el.scrollIntoView({behavior:'smooth', block:'start'});
  }, 60);
}
function showContact(){ window.location.href='/pages/contact'; }
function showFaq(){ goHomeThenScroll('.faq'); }

/* ============ POPPABLE CLOUDS ============ */
function popCloud(el){
  if(el.classList.contains('pop')) return;
  el.classList.add('pop');
  setTimeout(()=>el.classList.remove('pop'), 2600); // puffs away, then drifts back
}

/* ============ FEED THE GOAT  GRAZE (3 bites, then it's gone) ============ */
let grassLevel = 0;                 // 0 = full & tall; eaten down each feed
const GRASS_MAX = 3;                // can be fed 3 times
const GRASS_H = [1, 0.55, 0.28, 0]; // grass height after 0,1,2,3 feeds (gone after 3  just meadow)
function graze(){
  const goat = document.getElementById('meadowGoat');
  const grass = document.getElementById('grazeGrass');
  const hint = document.getElementById('mgHint');
  if(goat.classList.contains('grazing')) return;   // mid-munch
  if(grassLevel >= GRASS_MAX) return;              // grass is gone — can't feed anymore
  goat.classList.add('grazing');                    // lean in & munch
  grassLevel++;
  if(grass) grass.style.transform = 'scaleY(' + GRASS_H[grassLevel] + ')'; // eaten shorter, stays short
  var mouth = document.getElementById('mgMouth');                            // mouth gets greener each bite
  if(mouth){ mouth.style.opacity = Math.min(0.92, grassLevel * 0.32); mouth.style.transform = 'scale(' + (0.7 + grassLevel * 0.12) + ')'; }
  if(grassLevel >= GRASS_MAX && hint) hint.textContent = 'all gone! ';
  setTimeout(()=>goat.classList.remove('grazing'), 1500);
}
const rainMilk = graze, eatGrass = graze; // aliases so existing calls still work

/* (meadow-goat morph runs at the very end, after all helpers are defined) */
const revealObserver = new IntersectionObserver((entries)=>{
  entries.forEach(e=>{ if(e.isIntersecting) e.target.classList.add('in'); });
}, {threshold:0.3});
document.querySelectorAll('.transform-sec').forEach(el=>revealObserver.observe(el));

/* ============ MILK-THE-GOAT POPUP ============ */
var milkClicks = 0;
function openPopup(){
  var pg = document.getElementById('popGoat');
  if(pg && !pg.dataset.filled){ pg.innerHTML = '<img src="' + GOAT_IMG + '" alt="Creamy Meadow goat" loading="lazy" decoding="async">'; pg.dataset.filled = '1'; }
  var p = document.getElementById('popup'); if(p) p.classList.add('open');
  var cc = document.getElementById('code'); if(cc) cc.textContent = STORE.discountCode;
}
// Step 1: validate and save the email, then show the milking game.
function startMilking(event){
  if(event) event.preventDefault();

  var form = document.getElementById('CreamyMeadowPopupForm');
  var input = document.getElementById('popEmail');
  var error = document.getElementById('emailErr');
  var button = document.getElementById('popupEmailButton');
  var email = input ? input.value.trim() : '';

  if(!input || !input.checkValidity()){
    if(error){
      error.textContent = 'Hmm, that doesn’t look like an email.';
      error.style.display = 'block';
    }
    if(input){
      input.reportValidity();
      input.focus();
    }
    return false;
  }

  if(error) error.style.display = 'none';

  var oldText = button ? button.textContent : '';
  if(button){
    button.disabled = true;
    button.textContent = 'Saving…';
  }

  sendEmailLead(email, 'gift-popup', form).then(function(saved){
    if(!saved) throw new Error('Shopify did not accept the email.');

    cmMarkEmailCaptured();

    var emailStep = document.getElementById('emailStep');
    var milkStep = document.getElementById('milkStep');

    if(emailStep) emailStep.style.display = 'none';
    if(milkStep) milkStep.style.display = '';
  }).catch(function(captureError){
    console.error('[Creamy Meadow] Gift popup signup failed:', captureError);
    if(error){
      error.textContent = 'We couldn’t save that email. Please try again.';
      error.style.display = 'block';
    }
  }).then(function(){
    if(button){
      button.disabled = false;
      button.textContent = oldText;
    }
  });

  return false;
}
// step 2: tap the goat — 2 hits fills the jug and the code appears inside it
function milkGoat(){
  if(milkClicks >= 2) return;
  milkClicks++;
  var fill = document.getElementById('milkFill');
  if(fill) fill.style.height = Math.min(100, milkClicks * 50) + '%';
  var drop = document.getElementById('milkDrop');
  if(drop){ drop.classList.remove('go'); void drop.offsetWidth; drop.classList.add('go'); }
  var pg = document.getElementById('popGoat');
  if(pg){ pg.classList.remove('pop'); void pg.offsetWidth; pg.classList.add('pop'); }
  if(milkClicks >= 2){
    setTimeout(function(){
      var jug = document.getElementById('milkJug'); if(jug) jug.classList.add('full');
      var a = document.getElementById('jugActions'); if(a) a.classList.add('show');
      var h = document.getElementById('milkHint'); if(h) h.textContent = 'There it is — your 5% off code! 👇';
    }, 520);
  }
}
function closePopup(){
  var p = document.getElementById('popup'); if(p) p.classList.remove('open');
  // reset the whole flow for next open
  milkClicks = 0;
  var e = document.getElementById('emailStep'); if(e) e.style.display = '';
  var m = document.getElementById('milkStep'); if(m) m.style.display = 'none';
  var fill = document.getElementById('milkFill'); if(fill) fill.style.height = '0';
  var jug = document.getElementById('milkJug'); if(jug) jug.classList.remove('full');
  var a = document.getElementById('jugActions'); if(a) a.classList.remove('show');
  var err = document.getElementById('emailErr'); if(err){ err.classList.remove('show'); err.style.display = 'none'; }
  var h = document.getElementById('milkHint'); if(h) h.textContent = 'Two good squeezes fills the jug.';
}

// Show the gift popup once per browsing session until an email is captured.
function cmHasCapturedEmail(){
  try{
    return localStorage.getItem('cm_email_captured') === '1';
  }catch(error){
    return false;
  }
}

function cmGiftShownThisSession(){
  try{
    return sessionStorage.getItem('cm_gift_shown') === '1';
  }catch(error){
    return false;
  }
}

function cmMarkGiftShownThisSession(){
  try{
    sessionStorage.setItem('cm_gift_shown', '1');
  }catch(error){}
}

if(!cmHasCapturedEmail() && !cmGiftShownThisSession()){
  setTimeout(function(){
    openPopup();
    cmMarkGiftShownThisSession();
  }, 4000);
}

// Connect the native Shopify customer forms to the custom no-reload experience.
var _cmNewsletterForm = document.getElementById('CreamyMeadowNewsletterForm');
if(_cmNewsletterForm){
  _cmNewsletterForm.addEventListener('submit', subscribeNewsletter);
}

var _cmPopupForm = document.getElementById('CreamyMeadowPopupForm');
if(_cmPopupForm){
  _cmPopupForm.addEventListener('submit', startMilking);
}
// close on backdrop click or Esc
var _pu = document.getElementById('popup');
if(_pu) _pu.addEventListener('click', e=>{
  if(e.target.id === 'popup') closePopup();
});
document.addEventListener('keydown', e=>{ if(e.key==='Escape') closePopup(); });

// (popup is the milk-the-goat game: email first, then 2 hits reveal the code in the jug)

function copyCode(){
  var el = document.getElementById('code'); if(!el) return;
  if(navigator.clipboard) navigator.clipboard.writeText(el.textContent.trim());
  var b = document.getElementById('copybtn'); if(!b) return;
  b.textContent = "Copied!";
  setTimeout(function(){ b.textContent = "Copy code"; }, 1600);
}
function goToQuiz(){
  closePopup();
  showPage('quiz');
}

/* ============ SHOP + PRODUCT PAGE + CART ============ */
const PRODUCT_IMGS = {"Original": CMIMG[4], "Sage": CMIMG[5], "Daisy": CMIMG[6], "Atlas": CMIMG[7], "Willow": CMIMG[8], "Variety Pack": CMIMG[9]};
const BENEFITS_IMG = CMIMG[10];
var SHOP = [
  {n:'Original', s:'Unscented',        c:'#f4ead2'},
  {n:'Sage',     s:'Lavender & Oat',   c:'#c4b6df'},
  {n:'Daisy',    s:'Honey & Almond',   c:'#e9cf85'},
  {n:'Atlas',    s:'Cedar & Sea Salt', c:'#7fa8c4'},
  {n:'Willow',   s:'Rose & Vanilla',   c:'#f3c4d2'},
  {n:'Variety Pack', s:'All 5 scents', c:'#e7d9bf', variety:true}
];
// Launch pricing with FREE SHIPPING ON EVERY ORDER.
// Bundle savings are measured against a $13 single-bar value.
var REGULAR_BAR_PRICE = 13.00;
var PACKS = [
  {label:'Single Bar', qty:1, once:12.99, sub:11.69, months:1},
  {label:'3-Pack', qty:3, once:29.99, sub:26.99, months:3, popular:true},
  {label:'6-Pack', qty:6, once:49.99, sub:44.99, months:6}
];
// variety pack — one bar of every scent (5 bars)
var VARIETY_PACKS = [
  {label:'5-Pack — one of each scent', qty:5, once:49.99, sub:44.99, months:3, scents:['Original','Sage','Daisy','Atlas','Willow']}
];
/* Keep the Creamy Meadow cart after refresh */
var CM_CART_STORAGE_KEY = 'creamy_meadow_cart_v4';

function cmLoadSavedCart(){
  try {
    var savedCart = localStorage.getItem(CM_CART_STORAGE_KEY);

    if(!savedCart){
      return [];
    }

    var parsedCart = JSON.parse(savedCart);

    return Array.isArray(parsedCart)
      ? parsedCart
      : [];
  } catch(error) {
    console.warn('[Creamy Meadow] Could not load saved cart:', error);
    return [];
  }
}

function cmSaveCart(){
  try {
    localStorage.setItem(
      CM_CART_STORAGE_KEY,
      JSON.stringify(cart)
    );
  } catch(error) {
    console.warn('[Creamy Meadow] Could not save cart:', error);
  }
}

function cmClearSavedCart(){
  try {
    localStorage.removeItem(CM_CART_STORAGE_KEY);
  } catch(error) {}
}

/* {key,n,s,c,label,price,qty} */
var cart = cmLoadSavedCart();
function money(x){ return '$' + x.toFixed(2); }
function tint(hex){ var h=hex.replace('#',''); var r=parseInt(h.substr(0,2),16),g=parseInt(h.substr(2,2),16),b=parseInt(h.substr(4,2),16); return 'rgba('+r+','+g+','+b+',0.30)'; }

/* --- shop grid: a catalog that opens each soap's page --- */
function renderShop(){
  var grid = document.getElementById('shopGrid'); if(!grid) return;
  grid.innerHTML = SHOP.map(function(p,i){
    return '<div class="shop-card" onclick="showProduct('+i+')">'
      + '<img class="shop-photo" src="'+(PRODUCT_IMGS[p.n]||SOAP_IMG)+'" alt="'+p.n+' goat milk soap" loading="lazy" decoding="async" width="780" height="780">'
      + '<div class="shop-name">'+p.n+'</div>'
      + '<div class="shop-scent">'+p.s+'</div>'
      + '<div class="shop-from">from '+money((p.variety?VARIETY_PACKS:PACKS)[0].sub)+'</div>'
      + '<div class="cm-shop-free-ship">FREE SHIPPING</div>'
      + '<button class="shop-add" onclick="event.stopPropagation();showProduct('+i+')">View soap</button>'
    + '</div>';
  }).join('');
}

/* --- product detail page (PDP) --- */
var currentProduct = 0, pdpType = 'sub', pdpPack = 1, pdpImg = 0, pdpFrequency = 3;   // default: 3-pack, subscribe; delivery timing follows the selected pack
var PRODUCT_GALLERY = {
  "Original": [
  CMIMG[11],
  CMIMG[12],
  CMIMG[13],
  CMIMG[14]
]
};
// use the new Original photography for the shop card & checkout thumbnail too
PRODUCT_IMGS['Original'] = PRODUCT_GALLERY['Original'][0];
PRODUCT_GALLERY['Sage'] = [
  CMIMG[15],
  CMIMG[16],
  CMIMG[17],
  CMIMG[18],
  CMIMG[19]
];
PRODUCT_GALLERY['Daisy'] = [
  CMIMG[20],
  CMIMG[21],
  CMIMG[22],
  CMIMG[23],
  CMIMG[24]
];
PRODUCT_GALLERY['Willow'] = [
  CMIMG[25],
  CMIMG[26],
  CMIMG[27],
  CMIMG[28],
  CMIMG[29]
];
PRODUCT_GALLERY['Atlas'] = [
  CMIMG[30],
  CMIMG[31],
  CMIMG[32],
  CMIMG[33],
  CMIMG[34]
];
PRODUCT_IMGS['Sage'] = PRODUCT_GALLERY['Sage'][0];
PRODUCT_IMGS['Daisy'] = PRODUCT_GALLERY['Daisy'][0];
PRODUCT_IMGS['Willow'] = PRODUCT_GALLERY['Willow'][0];
PRODUCT_IMGS['Atlas'] = PRODUCT_GALLERY['Atlas'][0];
/* ===== Variety Pack open-box hero image (added) ===== */
function _goatGlyph(x,y,sc){
  return '<g transform="translate('+x+' '+y+') scale('+sc+')" fill="none" stroke="#9c8552" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round">'
    + '<path d="M-13 -9 C-20 -20 -15 -29 -9 -25"/><path d="M13 -9 C20 -20 15 -29 9 -25"/>'
    + '<path d="M-11 0 C-11 12 -5 18 0 18 C5 18 11 12 11 0 C11 -10 6 -15 0 -15 C-6 -15 -11 -10 -11 0 Z"/>'
    + '<path d="M-11 -1 L-19 1"/><path d="M11 -1 L19 1"/>'
    + '<circle cx="-4" cy="0" r="1.6" fill="#9c8552" stroke="none"/><circle cx="4" cy="0" r="1.6" fill="#9c8552" stroke="none"/>'
    + '<path d="M-2 16 C0 21 2 21 2 16"/></g>';
}
function _vbar(x,y,w,h,c){
  return '<g transform="translate('+x+' '+y+')">'
    + '<rect x="0" y="7" width="'+w+'" height="'+h+'" rx="15" fill="#28475a" opacity=".16"/>'
    + '<rect x="0" y="0" width="'+w+'" height="'+h+'" rx="15" fill="'+c+'" stroke="#28475a" stroke-width="3"/>'
    + '<rect x="2" y="2" width="'+(w-4)+'" height="'+(h*0.46)+'" rx="13" fill="#ffffff" opacity=".26"/>'
    + _goatGlyph(w/2, h/2-4, 0.92)
    + '<text x="'+(w/2)+'" y="'+(h-13)+'" text-anchor="middle" font-family="Georgia,serif" font-size="11" fill="#9c8552">goat milk soap</text>'
    + '</g>';
}
function varietyBoxSVG(){
  var C = {Original:'#f4ead2',Sage:'#c4b6df',Daisy:'#e9cf85',Atlas:'#7fa8c4',Willow:'#f3c4d2'};
  var s = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 760 620">'
    + '<defs>'
    + '<linearGradient id="vsky" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#d4ecf7"/><stop offset="1" stop-color="#e8f5fc"/></linearGradient>'
    + '<linearGradient id="vmead" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#8fb583"/><stop offset="1" stop-color="#6e9a63"/></linearGradient>'
    + '</defs>'
    + '<rect width="760" height="620" fill="#ffffff"/>'
    + '<ellipse cx="380" cy="586" rx="300" ry="24" fill="#28475a" opacity=".10"/>'
    + '<g>'
    + '<rect x="152" y="32" width="456" height="252" rx="18" fill="url(#vsky)" stroke="#28475a" stroke-width="3"/>'
    + '<circle cx="232" cy="98" r="19" fill="#fff" opacity=".92"/><circle cx="262" cy="98" r="26" fill="#fff" opacity=".92"/><circle cx="298" cy="100" r="17" fill="#fff" opacity=".92"/>'
    + '<circle cx="486" cy="86" r="17" fill="#fff" opacity=".92"/><circle cx="512" cy="88" r="23" fill="#fff" opacity=".92"/>'
    + '<path d="M152 214 Q262 188 380 206 Q500 224 608 200 L608 284 L152 284 Z" fill="url(#vmead)"/>'
    + _goatGlyph(380,152,1.65)
    + '<text x="380" y="120" text-anchor="middle" font-family="Georgia,serif" font-style="italic" font-weight="bold" font-size="33" fill="#28475a">Creamy Meadow</text>'
    + '<text x="380" y="252" text-anchor="middle" font-family="Georgia,serif" font-weight="bold" font-size="17" letter-spacing="3" fill="#ffffff">GOAT MILK SOAP</text>'
    + '<text x="380" y="274" text-anchor="middle" font-family="Georgia,serif" font-style="italic" font-size="15" fill="#eaf6ee">Variety Pack</text>'
    + '</g>'
    + '<g>'
    + '<rect x="94" y="298" width="572" height="252" rx="20" fill="#bfe0f0" stroke="#28475a" stroke-width="3"/>'
    + '<rect x="94" y="298" width="572" height="156" rx="20" fill="#e8f5fc"/>'
    + '<path d="M94 508 Q230 488 380 504 Q530 520 666 500 L666 532 L94 532 Z" fill="url(#vmead)" opacity=".96"/>'
    + '</g>'
    + _vbar(152,330,150,118,C.Original)
    + _vbar(305,330,150,118,C.Sage)
    + _vbar(458,330,150,118,C.Daisy)
    + _vbar(228,432,150,118,C.Atlas)
    + _vbar(381,432,150,118,C.Willow)
    + '</svg>';
  return 'data:image/svg+xml;utf8,' + encodeURIComponent(s);
}
var VARIETY_IMG = CMIMG[35];
PRODUCT_IMGS['Variety Pack'] = VARIETY_IMG;
PRODUCT_GALLERY['Variety Pack'] = [ VARIETY_IMG, PRODUCT_GALLERY['Original'][0], PRODUCT_GALLERY['Sage'][0], PRODUCT_GALLERY['Daisy'][0], PRODUCT_GALLERY['Atlas'][0], PRODUCT_GALLERY['Willow'][0] ];

// (superseded) PRODUCT_GALLERY['Variety Pack'] = [ PRODUCT_GALLERY['Original'][0], PRODUCT_GALLERY['Sage'][0], PRODUCT_GALLERY['Daisy'][0], PRODUCT_GALLERY['Willow'][0], PRODUCT_GALLERY['Atlas'][0] ];
// === real uploaded product photos (3-pack shots) ===
var IMG_ORIGINAL = CMIMG[36];
var IMG_SAGE = CMIMG[37];
var IMG_DAISY = CMIMG[38];
var IMG_WILLOW = CMIMG[39];
var IMG_ATLAS = CMIMG[40];
var IMG_VARIETY = CMIMG[41];
PRODUCT_GALLERY['Original'] = [IMG_ORIGINAL].concat(PRODUCT_GALLERY['Original']);
PRODUCT_GALLERY['Sage'] = [IMG_SAGE].concat(PRODUCT_GALLERY['Sage']);
PRODUCT_GALLERY['Daisy'] = [IMG_DAISY].concat(PRODUCT_GALLERY['Daisy']);
PRODUCT_GALLERY['Willow'] = [IMG_WILLOW].concat(PRODUCT_GALLERY['Willow']);
PRODUCT_GALLERY['Atlas'] = [IMG_ATLAS].concat(PRODUCT_GALLERY['Atlas']);
PRODUCT_GALLERY['Variety Pack'] = [IMG_VARIETY].concat(PRODUCT_GALLERY['Variety Pack']);
PRODUCT_IMGS['Original'] = IMG_ORIGINAL;
PRODUCT_IMGS['Sage'] = IMG_SAGE;
PRODUCT_IMGS['Daisy'] = IMG_DAISY;
PRODUCT_IMGS['Willow'] = IMG_WILLOW;
PRODUCT_IMGS['Atlas'] = IMG_ATLAS;
PRODUCT_IMGS['Variety Pack'] = IMG_VARIETY;


// === 6-bar (6-pack) product photos ===
var IMG6_ORIGINAL = CMIMG[42];
var IMG6_SAGE = CMIMG[43];
var IMG6_DAISY = CMIMG[44];
var IMG6_WILLOW = CMIMG[45];
var IMG6_ATLAS = CMIMG[46];
if(PRODUCT_GALLERY['Original']) PRODUCT_GALLERY['Original'].splice(2,0,IMG6_ORIGINAL);
if(PRODUCT_GALLERY['Sage']) PRODUCT_GALLERY['Sage'].splice(2,0,IMG6_SAGE);
if(PRODUCT_GALLERY['Daisy']) PRODUCT_GALLERY['Daisy'].splice(2,0,IMG6_DAISY);
if(PRODUCT_GALLERY['Willow']) PRODUCT_GALLERY['Willow'].splice(2,0,IMG6_WILLOW);
if(PRODUCT_GALLERY['Atlas']) PRODUCT_GALLERY['Atlas'].splice(2,0,IMG6_ATLAS);




// === ingredients (back of box) photo — shown on every soap ===
var IMG_INGREDIENTS = CMIMG[47];
if(PRODUCT_GALLERY['Original']) PRODUCT_GALLERY['Original'].push(IMG_INGREDIENTS);
if(PRODUCT_GALLERY['Sage']) PRODUCT_GALLERY['Sage'].push(IMG_INGREDIENTS);
if(PRODUCT_GALLERY['Daisy']) PRODUCT_GALLERY['Daisy'].push(IMG_INGREDIENTS);
if(PRODUCT_GALLERY['Willow']) PRODUCT_GALLERY['Willow'].push(IMG_INGREDIENTS);
if(PRODUCT_GALLERY['Atlas']) PRODUCT_GALLERY['Atlas'].push(IMG_INGREDIENTS);
if(PRODUCT_GALLERY['Variety Pack']) PRODUCT_GALLERY['Variety Pack'].push(IMG_INGREDIENTS);

function pdpGallery(){ var p = SHOP[currentProduct]; if (PRODUCT_GALLERY[p.n]) return PRODUCT_GALLERY[p.n].slice(); return [(PRODUCT_IMGS[p.n]||SOAP_IMG), BENEFITS_IMG]; }
function showProduct(i, noPush){
  if(quizMatch && SHOP[i] && quizMatch.name!==SHOP[i].n) quizMatch=null;
  currentProduct = i;
  pdpType = 'sub';
  pdpPack = 1;
  pdpImg = 0;
  pdpFrequency = 1;
  pdpRender();
  showPage('product');
  if(SHOP[i]) cmPrimeShopifyProduct(SHOP[i].n);
  if(!noPush && SHOP[i]) cmSyncUrl('/products/'+(CM_HANDLES[SHOP[i].n]||''));
}
/* ---- real product URLs (deep-linking to /products/{handle}) ---- */
var CM_HANDLES = {
  'Original':'original-goat-milk-soap',
  'Sage':'sage-lavender-oat-goat-milk-soap',
  'Daisy':'daisy-honey-almond-goat-milk-soap',
  'Atlas':'atlas-cedar-sea-salt-goat-milk-soap',
  'Willow':'willow-rose-vanilla-goat-milk-soap',
  'Variety Pack':'variety-pack-goat-milk-soap'
};


/* ---- Shopify product + subscription data ----
   The storefront Product Ajax API supplies each variant's selling-plan
   allocations. The custom Creamy Meadow selector stays visible; Shopify's
   default subscription widget is not required for the purchase flow. */
var CM_SHOPIFY_PRODUCTS = {};
var CM_SHOPIFY_PRODUCT_REQUESTS = {};

function cmShopifyRoot(){
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  return /\/$/.test(root) ? root : root + '/';
}
function cmSkuFor(name, packQty){
  var code = {
    'Original':'ORIG',
    'Sage':'SAGE',
    'Daisy':'DAISY',
    'Atlas':'ATLAS',
    'Willow':'WILLOW',
    'Variety Pack':'VARIETY'
  }[name] || '';
  return 'CM-' + code + '-' + packQty;
}
function cmLoadShopifyProduct(name){
  if(CM_SHOPIFY_PRODUCTS[name]) return Promise.resolve(CM_SHOPIFY_PRODUCTS[name]);
  if(CM_SHOPIFY_PRODUCT_REQUESTS[name]) return CM_SHOPIFY_PRODUCT_REQUESTS[name];

  var handle = CM_HANDLES[name];
  if(!handle) return Promise.reject(new Error('Missing Shopify product handle for ' + name + '.'));

  CM_SHOPIFY_PRODUCT_REQUESTS[name] = fetch(cmShopifyRoot() + 'products/' + handle + '.js', {
    credentials: 'same-origin',
    headers: { 'Accept': 'application/json' }
  }).then(function(response){
    if(!response.ok) throw new Error('Could not load ' + name + ' from Shopify.');
    return response.json();
  }).then(function(product){
    CM_SHOPIFY_PRODUCTS[name] = product;
    delete CM_SHOPIFY_PRODUCT_REQUESTS[name];
    return product;
  }).catch(function(error){
    delete CM_SHOPIFY_PRODUCT_REQUESTS[name];
    throw error;
  });

  return CM_SHOPIFY_PRODUCT_REQUESTS[name];
}
function cmPrimeShopifyProduct(name){
  cmLoadShopifyProduct(name).then(function(){
    var current = SHOP[currentProduct];
    if(current && current.n === name && document.getElementById('productDetail')) pdpRender();
  }).catch(function(error){
    console.warn('[Creamy Meadow] Shopify product data:', error.message || error);
  });
}
function cmFindVariant(product, name, packQty){
  if(!product || !product.variants) return null;
  var wantedSku = cmSkuFor(name, packQty);
  var fallbackId = window.SHOPIFY_VARIANTS && window.SHOPIFY_VARIANTS[wantedSku];
  var variant = product.variants.filter(function(v){ return String(v.sku || '').toUpperCase() === wantedSku; })[0];
  if(!variant && fallbackId){
    variant = product.variants.filter(function(v){ return String(v.id) === String(fallbackId); })[0];
  }
  return variant || null;
}
// Frequency selection was intentionally removed from the product page.
// Shopify's attached default selling plan now controls Subscribe & Save delivery.

function cmFrequencyLabel(months){
  return Number(months) === 1 ? 'Every month' : 'Every ' + Number(months) + ' months';
}
function cmDeliveryText(months){
  var n = Number(months || 1);
  return n === 1 ? 'Delivers every month' : 'Delivers every ' + n + ' months';
}
function cmPackSubscriptionLine(pk){
  return pk.qty === 1
    ? '1 bar delivered every month'
    : pk.qty + ' bars delivered every ' + Number(pk.months || pk.qty) + ' months';
}

function cmSellingPlanMap(product){
  var map = {};
  ((product && product.selling_plan_groups) || []).forEach(function(group){
    (group.selling_plans || []).forEach(function(plan){
      map[String(plan.id)] = plan;
    });
  });
  return map;
}

function cmPlanSearchText(plan){
  if(!plan) return '';
  var bits = [plan.name || '', plan.description || ''];
  (plan.options || []).forEach(function(option){
    if(typeof option === 'string'){
      bits.push(option);
    }else if(option){
      bits.push(option.name || '', option.value || '');
    }
  });
  return bits.join(' ').toLowerCase();
}

function cmPlanMonths(plan){
  if(!plan) return null;

  // Prefer Shopify's real delivery/billing policy when the product JSON exposes it.
  var delivery = plan.delivery_policy || plan.deliveryPolicy || {};
  var billing = plan.billing_policy || plan.billingPolicy || {};
  var policy = delivery.interval ? delivery : billing;
  var interval = String(policy.interval || '').toLowerCase();
  var count = Number(policy.interval_count || policy.intervalCount || 1);

  if(interval === 'month' && [1,3,6].indexOf(count) !== -1) return count;
  if(interval === 'year' && count === 1) return 12;

  // Fallback for Shopify/app data that only exposes a plan name or option value.
  var text = cmPlanSearchText(plan);
  var explicit = text.match(/\b(1|3|6)\s*(?:month|months|mo)\b/i);
  if(explicit) return Number(explicit[1]);
  if(/\bmonthly\b|\bevery\s+month\b/i.test(text)) return 1;
  if(/\bquarterly\b|\bevery\s+quarter\b/i.test(text)) return 3;
  if(/\bsemi[- ]?annual(?:ly)?\b|\bbiannual(?:ly)?\b|\btwice\s+(?:a|per)\s+year\b/i.test(text)) return 6;
  return null;
}

function cmSellingPlansForVariant(product, variant){
  var allocations = (variant && variant.selling_plan_allocations) || [];
  var planMap = cmSellingPlanMap(product);

  return allocations.map(function(allocation){
    var id = String(
      allocation.selling_plan_id ||
      (allocation.selling_plan && allocation.selling_plan.id) ||
      ''
    );
    var meta = planMap[id] || allocation.selling_plan || {};
    return {
      id:id,
      name:meta.name || 'Subscribe & Save',
      months:cmPlanMonths(meta),
      price:Number(allocation.price),
      compareAtPrice:Number(allocation.compare_at_price || variant.price),
      allocation:allocation,
      meta:meta
    };
  }).filter(function(plan){ return !!plan.id; });
}

function cmFindSellingPlan(product, variant, months){
  var plans = cmSellingPlansForVariant(product, variant);
  if(!plans.length) return null;

  // No customer-facing 1/3/6 month chooser. The selected pack controls timing:
  // Single Bar -> every 1 month, 3-Pack -> every 3 months, 6-Pack -> every 6 months.
  var wanted = Number(months || 1);
  var exact = plans.filter(function(plan){ return plan.months === wanted; })[0];
  return exact || plans[0];
}

function cmTierShopifyData(productName, packQty, purchaseType, months){
  var product = CM_SHOPIFY_PRODUCTS[productName];
  if(!product) return null;
  var variant = cmFindVariant(product, productName, packQty);
  if(!variant) return null;
  var plan = purchaseType === 'sub' ? cmFindSellingPlan(product, variant, months || 1) : null;
  return {
    product:product,
    variant:variant,
    plan:plan,
    price:purchaseType === 'sub' && plan ? plan.price / 100 : Number(variant.price) / 100
  };
}

// The storefront always displays the prices chosen below in PACKS and
// VARIETY_PACKS. Shopify still controls the amount charged at checkout, so
// the matching variant and selling plan must use these same prices in admin.
function cmTierDisplayPrice(product, pack, purchaseType){
  return purchaseType === 'sub' ? pack.sub : pack.once;
}

function cmEnsureSubscriptionStyles(){
  if(document.getElementById('cm-subscription-frequency-styles')) return;
  var style = document.createElement('style');
  style.id = 'cm-subscription-frequency-styles';
  style.textContent =
    '.cm-sub-note{margin:10px 0 12px;padding:10px 12px;border:1px solid #b7d9ea;border-radius:12px;background:#f7fcff;color:#557082;text-align:center;font-family:Nunito,sans-serif;font-size:12px;font-weight:800;line-height:1.35}' +
    '.cm-free-ship-banner{margin:12px 0 10px;padding:10px 13px;border:2px solid #8fb583;border-radius:12px;background:#eef7eb;color:#28475a;text-align:center;font-family:Nunito,sans-serif;font-size:13px;font-weight:900;letter-spacing:.04em}' +
    '.pk-ship{display:block;margin-top:4px;color:#6e9a63;font-size:10px;font-weight:900;letter-spacing:.06em}' +
    '.pk-delivery{display:block;margin-top:3px;color:#28475a;font-size:11px;font-weight:900;letter-spacing:.01em}' +
    '.cm-shop-free-ship{margin:4px 0 10px;color:#6e9a63;font-family:Nunito,sans-serif;font-size:11px;font-weight:900;letter-spacing:.07em}' +
    '@media(max-width:560px){.cm-sub-note{margin:8px 0 10px;padding:9px 10px;font-size:11px}.cm-free-ship-banner{font-size:12px;padding:9px 10px}}';
  document.head.appendChild(style);
}

function cmNameFromHandle(h){ for(var k in CM_HANDLES){ if(CM_HANDLES[k]===h) return k; } return null; }
function cmProductIndex(name){ for(var i=0;i<SHOP.length;i++){ if(SHOP[i].n===name) return i; } return -1; }
function cmSyncUrl(path){ try{ if(location.pathname!==path){ history.pushState({cm:1}, '', path); } }catch(e){} }
function cmRouteFromLocation(){
  var m = (location.pathname||'').match(/\/products\/([^\/?#]+)/);
  if(m){ var name=cmNameFromHandle(m[1]); var idx = name?cmProductIndex(name):-1; if(idx>=0){ showProduct(idx, true); return true; } }
  return false;
}
function pdpShowImage(i){
  var g = pdpGallery(); if(!g.length) return;
  pdpImg = ((i % g.length) + g.length) % g.length;   // wraps both directions -> always loops
  var photos = document.querySelectorAll('#productDetail .pdp-photo');
  for(var j=0;j<photos.length;j++){ photos[j].classList.toggle('on', j===pdpImg); }
  var thumbs = document.querySelectorAll('#productDetail .pdp-thumb');
  for(var k=0;k<thumbs.length;k++){ thumbs[k].classList.toggle('on', k===pdpImg); }
}
function pdpStep(d){ pdpShowImage(pdpImg + d); }   // next/prev, loops past the ends
function pdpGo(i){ pdpShowImage(i); }
function pdpSetType(t){ pdpType = t; pdpRender(); }
function pdpSetFrequency(months){ pdpFrequency = Number(months) || 1; pdpRender(); }
function pdpSetPack(k){
  pdpPack = k;
  var p = SHOP[currentProduct];
  var tiers = p.variety ? VARIETY_PACKS : PACKS;
  if(tiers[k]) pdpFrequency = Number(tiers[k].months || tiers[k].qty || 1);
  if(!p.variety){
    // Single Bar -> 1-bar photo, 3-Pack -> 3-bar photo, 6-Pack -> 6-bar photo.
    pdpImg = (k === 0) ? 1 : (k === 2 ? 2 : 0);
  }
  pdpRender();
}
function packIcon(qty, color){
  // little soap bars representing quantity: 1 / 3 / 6 bars in the soap's color
  var n = qty, W = 66, H = 50, gap = 4, padX = 5, padY = 5;
  var cols = Math.min(n, 3), rows = Math.ceil(n / 3);
  var cellW = ((W - 2 * padX) - (cols - 1) * gap) / cols;
  var cellH = ((H - 2 * padY) - (rows - 1) * gap) / rows;
  var bw = Math.min(cellW, 30);
  var bh = Math.min(cellH, bw * 0.72);            // keep soap-bar proportions
  var rx = Math.max(2, bh * 0.24);
  var gridH = rows * cellH + (rows - 1) * gap;
  var startCY = (H - gridH) / 2 + cellH / 2;
  var bars = '';
  for(var i = 0; i < n; i++){
    var row = Math.floor(i / 3), col = i - row * 3;
    var inRow = Math.min(n - row * 3, 3);
    var rowStartCX = (W - (inRow * cellW + (inRow - 1) * gap)) / 2 + cellW / 2;
    var cx = rowStartCX + col * (cellW + gap);
    var cy = startCY + row * (cellH + gap);
    var bx = cx - bw / 2, by = cy - bh / 2;
    bars += '<g transform="translate('+bx.toFixed(1)+','+by.toFixed(1)+')">'
      + '<rect width="'+bw.toFixed(1)+'" height="'+bh.toFixed(1)+'" rx="'+rx.toFixed(1)+'" fill="'+color+'" stroke="rgba(40,71,90,.45)" stroke-width="1.2"/>'
      + '<rect x="1.5" y="1.2" width="'+(bw-3).toFixed(1)+'" height="'+Math.max(1.5, bh*0.32).toFixed(1)+'" rx="'+Math.max(1, rx-1).toFixed(1)+'" fill="rgba(255,255,255,.5)"/>'
      + '</g>';
  }
  return '<svg viewBox="0 0 '+W+' '+H+'" width="100%" height="100%" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" style="display:block">'+bars+'</svg>';
}
function varietyScentText(arr){
  var order = [], counts = {};
  arr.forEach(function(s){ if(counts[s]===undefined){ order.push(s); counts[s]=0; } counts[s]++; });
  return order.map(function(s){ return counts[s]>1 ? s+' ×'+counts[s] : s; }).join(', ');
}
function pdpRender(){
  var host = document.getElementById('productDetail'); if(!host) return;
  cmEnsureSubscriptionStyles();
  var p = SHOP[currentProduct];
  var gallery = pdpGallery();
  if(pdpImg >= gallery.length) pdpImg = 0;
  var thumbs = gallery.map(function(src,idx){ return '<button class="pdp-thumb '+(idx===pdpImg?'on':'')+'" style="background-image:url('+src+');background-size:cover;background-position:center" onclick="pdpGo('+idx+')" aria-label="Image '+(idx+1)+'"></button>'; }).join('');
  var photos = gallery.map(function(src,idx){ var alt = (src===BENEFITS_IMG) ? 'Why Creamy Meadow goat milk soap — made with fresh goat milk, gentle for dry and sensitive everyday skin, no harsh detergents' : (p.n+' goat milk soap bar'); var loading = idx===0 ? 'eager' : 'lazy'; var priority = idx===0 ? ' fetchpriority="high"' : ''; return '<img class="pdp-photo'+(idx===pdpImg?' on':'')+'" src="'+src+'" alt="'+alt+'" loading="'+loading+'" decoding="async" width="900" height="900"'+priority+'>'; }).join('');
  var tiers = p.variety ? VARIETY_PACKS : PACKS;
  if(pdpPack >= tiers.length) pdpPack = tiers.length - 1;
  var selectedPack = tiers[pdpPack];


  var packs = tiers.map(function(pk,k){
    var price = cmTierDisplayPrice(p, pk, pdpType);
    var regularTotal = pk.qty * REGULAR_BAR_PRICE;
    var save = regularTotal - price;
    var saveBadge = save>0.01 ? '<span class="pk-save">Save '+money(save)+'</span>' : '';
    var pop = pk.popular ? '<span class="pk-pop">Most Popular</span>' : '';
    var strike = regularTotal>price+0.01 ? '<small>'+money(regularTotal)+'</small>' : '';
    var months = Number(pk.months || pk.qty || 1);
    var schedule = pdpType === 'sub' ? cmPackSubscriptionLine(pk) : 'One-time checkout only';
    var isSelected = k === pdpPack;
    var detail = '';
    if(isSelected){
      detail = pdpType === 'sub'
        ? '<div class="pk-detail pk-detail-sub">'
          + '<strong>Subscribe &amp; Save for this pack</strong>'
          + '<ul>'
            + '<li>'+cmPackSubscriptionLine(pk)+'</li>'
            + '<li>'+cmDeliveryText(months)+'</li>'
            + '<li>Free shipping included every order</li>'
            + '<li>Pause, skip, or cancel anytime</li>'
          + '</ul>'
        + '</div>'
        : '<div class="pk-detail pk-detail-once">'
          + '<strong>One-time purchase for this pack</strong>'
          + '<ul>'
            + '<li>No subscription</li>'
            + '<li>Checkout once and try it first</li>'
            + '<li>Free shipping included</li>'
          + '</ul>'
        + '</div>';
    }
    return '<div class="pk-row '+(isSelected?'sel':'')+'" onclick="pdpSetPack('+k+')">'
      + '<div class="pk-main">'
        + '<span class="pk-radio"></span>'
        + '<span class="pk-label">'+pk.label+' '+saveBadge+'<small class="pk-delivery">'+schedule+'</small><small class="pk-ship">FREE SHIPPING</small></span>'
        + pop
        + '<span class="pk-price">'+money(price)+strike+'</span>'
      + '</div>'
      + detail
    + '</div>';
  }).join('');

  var selectedMonths = Number(selectedPack.months || selectedPack.qty || 1);
  pdpFrequency = selectedMonths;

  var addPrice = cmTierDisplayPrice(p, selectedPack, pdpType);
  var subLine = p.variety ? p.s + ' · one of every bar' : p.s + ' · handmade goat-milk bar';
  var scentLine = p.variety ? '<p class="pdp-scentlist">Includes: ' + varietyScentText(selectedPack.scents) + '</p>' : '';
  var benefits = p.variety
    ? '<ul class="pdp-benefits"><li>One bar of every Creamy Meadow scent</li><li>Made with fresh, creamy goat milk</li><li>Perfect for gifting — or finding your favorite</li></ul>'
    : '<ul class="pdp-benefits"><li>Made with fresh, creamy goat milk</li><li>Gentle — no harsh detergents or sulfates</li><li>Loves dry, sensitive, everyday skin</li></ul>';
  var starsLine = '<div class="pdp-stars">★★★★★</div>';
  host.innerHTML =
    '<a class="pdp-back" onclick="showPage(\'shop\')">‹ All soaps</a>'
  + '<div class="pdp">'
    + '<div class="pdp-media">'
      + '<div class="pdp-stage" style="background:#fff">'
        + '<button class="pdp-arrow prev" onclick="pdpStep(-1)" aria-label="Previous">‹</button>'
        + photos
        + '<button class="pdp-arrow next" onclick="pdpStep(1)" aria-label="Next">›</button>'
      + '</div>'
      + '<div class="pdp-thumbs">'+thumbs+'</div>'
    + '</div>'
    + '<div class="pdp-info">'
      + ((quizMatch && quizMatch.name===p.n)
          ? '<div class="pdp-match">'
              + '<div class="pdp-match-head">✨ This is your soap</div>'
              + (quizMatch.tag ? '<div class="pdp-match-tag">'+quizMatch.tag+'</div>' : '')
              + (quizMatch.why ? '<p class="pdp-match-why">'+quizMatch.why+'</p>' : '')
              + '<a class="pdp-match-retake" onclick="retakeQuiz()">↺ Retake the quiz</a>'
            + '</div>'
          : '')
      + starsLine
      + '<h1 class="pdp-title">'+p.n+'</h1>'
      + '<p class="pdp-sub">'+subLine+'</p>'
      + scentLine
      + benefits
      + '<div class="cm-free-ship-banner">🚚 FREE SHIPPING ON EVERY ORDER</div>'
      + '<div class="pdp-eyebrow"><span>CHOOSE PURCHASE OPTION</span></div>'
      + '<div class="pdp-type">'
        + '<button class="pt-opt '+(pdpType==='sub'?'sel':'')+'" onclick="pdpSetType(\'sub\')">Subscribe &amp; Save</button>'
        + '<button class="pt-opt '+(pdpType==='once'?'sel':'')+'" onclick="pdpSetType(\'once\')">One-time purchase</button>'
      + '</div>'
      + '<div class="pdp-eyebrow pdp-pack-eyebrow"><span>CHOOSE YOUR PACK</span></div>'
      + '<div class="pdp-packs">'+packs+'</div>'
      + '<button class="pdp-add" onclick="pdpAdd()">Add to cart — '+money(addPrice)+'</button>'
      + '<div class="pdp-trust"><span>🚚 FREE SHIPPING ON EVERY ORDER</span><span>↩ 30-day happiness guarantee</span><span>🐐 Small-batch, made by hand</span></div>'
      + '<div class="pdp-reason-pills"><span class="pdp-reason-pill">🐐 Fresh goat milk</span><span class="pdp-reason-pill">🌿 No harsh detergents</span><span class="pdp-reason-pill">🚚 Free shipping</span></div>'
      + '<div class="pdp-accordions">'
        + '<details class="pdp-acc" open><summary>why people switch</summary><div class="pdp-acc-content"><p>Regular soap can leave skin feeling tight or dry. Creamy Meadow bars are made to feel creamy, gentle, and simple for everyday showers.</p></div></details>'
        + '<details class="pdp-acc"><summary>what’s inside</summary><div class="pdp-acc-content"><p>Fresh goat milk plus simple nourishing oils. No harsh detergent feel, no overcomplicated ingredient story.</p></div></details>'
        + '<details class="pdp-acc"><summary>shipping &amp; subscription</summary><div class="pdp-acc-content"><ul><li>Free shipping on every order.</li><li>Single Bar ships monthly.</li><li>3-Pack ships every 3 months.</li><li>6-Pack ships every 6 months.</li><li>Pause, skip, or cancel anytime.</li></ul></div></details>'
        + '<details class="pdp-acc"><summary>how to use</summary><div class="pdp-acc-content"><p>Lather with water, wash as usual, then store the bar somewhere dry between uses so it lasts longer.</p></div></details>'
      + '</div>'
    + '</div>'
  + '</div>';
}
function pdpAdd(){
  var p = SHOP[currentProduct];
  var tiers = p.variety ? VARIETY_PACKS : PACKS;
  if(pdpPack >= tiers.length) pdpPack = tiers.length - 1;
  var pk = tiers[pdpPack];
  var addButton = document.querySelector('#productDetail .pdp-add');
  var oldButtonText = addButton ? addButton.textContent : '';

  if(addButton){ addButton.disabled = true; addButton.textContent = 'Adding…'; }

  cmLoadShopifyProduct(p.n).then(function(product){
    var variant = cmFindVariant(product, p.n, pk.qty);
    if(!variant) throw new Error('The ' + pk.label + ' Shopify variant could not be found. Check its SKU: ' + cmSkuFor(p.n, pk.qty));
    if(variant.available === false) throw new Error(pk.label + ' is currently sold out.');

    var planMonths = Number(pk.months || pk.qty || pdpFrequency || 1);
    var plan = pdpType === 'sub' ? cmFindSellingPlan(product, variant, planMonths) : null;
    if(pdpType === 'sub' && !plan){
      throw new Error(
        'Subscribe & Save is not attached to this pack yet. ' +
        'Attach a Shopify subscription selling plan to this product variant.'
      );
    }

    var configuredPrice = pdpType === 'sub' ? pk.sub : pk.once;
    var shopifyPrice = pdpType === 'sub' ? plan.price / 100 : Number(variant.price) / 100;

    // JavaScript cannot override Shopify checkout prices. Stop the add-to-cart
    // action when Shopify and the storefront disagree so customers never see
    // one price here and a higher price at checkout.
    if(Math.abs(shopifyPrice - configuredPrice) > 0.011){
      throw new Error(
        'Price setup mismatch: this page is set to ' + money(configuredPrice) +
        ', but Shopify is charging ' + money(shopifyPrice) + '. ' +
        (pdpType === 'sub'
          ? 'Update the subscription plan price or discount in Shopify Subscriptions.'
          : 'Update this variant price in Shopify Products.')
      );
    }

    var price = configuredPrice;
    var label = pk.label + ' · ' + (
      pdpType === 'sub'
        ? 'Subscribe & Save · ' + cmFrequencyLabel(planMonths)
        : 'One-time'
    );
    var sText = p.variety ? varietyScentText(pk.scents) : p.s;
    var planId = plan ? String(plan.id) : '';
    var key = p.n + '|' + pk.label + '|' + pdpType + '|' + planId;
    var line = cart.filter(function(l){ return l.key === key; })[0];

    if(line){
      line.qty++;
      line.price = price;
    } else {
      cart.push({
        key:key,
        n:p.n,
        s:sText,
        c:p.c,
        label:label,
        price:price,
        qty:1,
        pq:pk.qty,
        variantId:String(variant.id),
        sellingPlanId:planId || null,
        sellingPlanName:plan ? plan.name : null,
        frequencyMonths:pdpType === 'sub' ? planMonths : null
      });
    }

    updateCart();
    openCart();
  }).catch(function(error){
    console.error('[Creamy Meadow] Add to cart failed:', error);
    alert(error.message || 'This item could not be added. Please try again.');
  }).then(function(){
    if(addButton){ addButton.disabled = false; addButton.textContent = oldButtonText; }
  });
}

/* --- cart --- */
function changeQty(key, d){
  var line = cart.filter(function(l){ return l.key===key; })[0];
  if(!line) return;
  line.qty += d;
  if(line.qty <= 0) cart = cart.filter(function(l){ return l.key!==key; });
  updateCart();
}
function removeItem(key){ cart = cart.filter(function(l){ return l.key!==key; }); updateCart(); }
function cartCount(){ return cart.reduce(function(t,l){ return t + l.qty; }, 0); }
function cartTotal(){ return cart.reduce(function(t,l){ return t + l.qty * l.price; }, 0); }

function updateCart(){
  // Save every cart change so refreshing or reopening the site keeps the cart.
  cmSaveCart();

  var badge = document.getElementById('cartBadge');
  var n = cartCount();

  if(badge){
    badge.textContent = n;
    badge.style.display = n > 0 ? 'inline-block' : 'none';
  }

  var items = document.getElementById('cartItems');

  if(items){
    if(cart.length === 0){
      items.innerHTML = '<p class="cart-empty">Your cart is empty.<br>Go fill it with goat milk goodness 🐐</p>';
    } else {
      items.innerHTML = cart.map(function(l){
        return '<div class="cart-line">'
          + '<div class="cl-thumb cl-thumb-photo"><img src="'+(PRODUCT_IMGS[l.n]||CHECKOUT_IMG)+'" alt="'+l.n+' goat milk soap" loading="lazy" decoding="async"></div>'
          + '<div class="cl-info"><div class="cl-name">'+l.n+'</div>'
            + '<div class="cl-type">'+l.s+' · '+l.label+'</div>'
            + '<div class="qty"><button type="button" onclick="changeQty(\''+l.key+'\',-1)">−</button><span>'+l.qty+'</span><button type="button" onclick="changeQty(\''+l.key+'\',1)">+</button>'
            + '<button type="button" class="cl-rm" onclick="removeItem(\''+l.key+'\')">remove</button></div>'
          + '</div>'
          + '<div class="cl-price">'+money(l.price*l.qty)+'</div>'
        + '</div>';
      }).join('');
    }
  }

  var tot = document.getElementById('cartTotal');
  if(tot) tot.textContent = money(cartTotal());
}

function openCart(){
  updateCart();
  var d = document.getElementById('cartDrawer');
  var b = document.getElementById('cartBack');
  if(d) d.classList.add('open');
  if(b) b.classList.add('open');
}

function closeCart(){
  var d = document.getElementById('cartDrawer');
  var b = document.getElementById('cartBack');
  if(d) d.classList.remove('open');
  if(b) b.classList.remove('open');
}

// Restore the saved cart badge, items, and total after every page load.
document.addEventListener('DOMContentLoaded', function(){
  updateCart();
});

// Keep two open store tabs in sync when the cart changes in either tab.
window.addEventListener('storage', function(event){
  if(event.key !== CM_CART_STORAGE_KEY) return;
  cart = cmLoadSavedCart();
  updateCart();
});
/* ---- Shopify variant IDs (real, verified via /products/*.json on store 31de0y-a8) ----
   Keyed by SKU. checkout() builds "CM-<CODE>-<qty>" and looks the ID up here.
   Create Shopify variants for 1, 3, and 6 bars. One-time and subscribe use the same variant;
   recurring billing is handled by a Shopify subscription app, not a separate variant. */
var SHOPIFY_VARIANTS = {
  'CM-ORIG-1':'48525776748701','CM-ORIG-3':'48525776781469','CM-ORIG-6':'48525776814237',
  'CM-SAGE-1':'48525776879773','CM-SAGE-3':'48525776912541','CM-SAGE-6':'48525776945309',
  'CM-DAISY-1':'48525776978077','CM-DAISY-3':'48525777010845','CM-DAISY-6':'48525777043613',
  'CM-ATLAS-1':'48525777076381','CM-ATLAS-3':'48525777109149','CM-ATLAS-6':'48525777141917',
  'CM-WILLOW-1':'48525777174685','CM-WILLOW-3':'48525777207453','CM-WILLOW-6':'48525777240221',
  'CM-VARIETY-5':'48525777272989'
};
function checkout(){
  if(cart.length===0){ alert('Your cart is empty!'); return; }

  var checkoutButton = document.querySelector('.cart-co');
  var oldText = checkoutButton ? checkoutButton.textContent : '';
  if(checkoutButton){ checkoutButton.disabled = true; checkoutButton.textContent = 'Preparing checkout…'; }

  var items = [];
  var missing = [];
  cart.forEach(function(line){
    var variantId = line.variantId;
    if(!variantId){
      var sku = cmSkuFor(line.n, line.pq || 1);
      variantId = window.SHOPIFY_VARIANTS && window.SHOPIFY_VARIANTS[sku];
    }
    if(!variantId){ missing.push(line.n + ' ' + line.label); return; }

    var item = { id: Number(variantId), quantity: Number(line.qty) };
    if(line.sellingPlanId) item.selling_plan = Number(line.sellingPlanId);
    items.push(item);
  });

  if(missing.length){
    if(checkoutButton){ checkoutButton.disabled = false; checkoutButton.textContent = oldText; }
    alert('These Shopify variants are missing: ' + missing.join(', '));
    return;
  }

  fetch(cmShopifyRoot() + 'cart/clear.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({})
  }).then(function(response){
    if(!response.ok) throw new Error('Could not prepare the Shopify cart.');
    return fetch(cmShopifyRoot() + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    });
  }).then(function(response){
    return response.json().then(function(data){
      if(!response.ok){
        var message = data && (data.description || data.message);
        throw new Error(message || 'Shopify could not add the order to checkout.');
      }
      return data;
    });
  }).then(function(){
    window.location.href = cmShopifyRoot() + 'checkout';
  }).catch(function(error){
    console.error('[Creamy Meadow] Checkout failed:', error);
    alert(error.message || 'Checkout could not be started. Please try again.');
    if(checkoutButton){ checkoutButton.disabled = false; checkoutButton.textContent = oldText; }
  });
}

/* ---- mobile hamburger menu ---- */
function toggleMenu(){
  var n=document.querySelector('.navlinks'), b=document.querySelector('.nav-toggle');
  if(!n) return;
  var open=n.classList.toggle('open');
  if(b) b.setAttribute('aria-expanded', open?'true':'false');
}
function closeMenu(){
  var n=document.querySelector('.navlinks'), b=document.querySelector('.nav-toggle');
  if(n) n.classList.remove('open');
  if(b) b.setAttribute('aria-expanded','false');
}
var _navLinks=document.querySelector('.navlinks');
if(_navLinks) _navLinks.addEventListener('click', function(e){ if(e.target.closest('a, .navcart')) closeMenu(); });



// trait axes per answer: e=energy, s=social, a=adventure, si=silliness
const questions = [
  {
    q:"How does your skin usually feel?",
    opts:[
      {t:"Dry and tight, especially after washing", k:"dry"},
      {t:"Sensitive — it stings or reacts easily", k:"sensitive"},
      {t:"Oily or breakout-prone", k:"oily"},
      {t:"Pretty balanced, no big complaints", k:"normal"},
    ]
  },
  {
    q:"Do any of these sound like you?",
    opts:[
      {t:"Eczema-prone or very reactive skin", k:"reactive"},
      {t:"Fragrances often bother my skin", k:"fragrance"},
      {t:"Nope, none of those", k:"none"},
    ]
  },
  {
    q:"Pick a scent vibe you'd actually enjoy.",
    opts:[
      {t:"Keep it unscented", k:"unscented"},
      {t:"Soft & floral", k:"floral"},
      {t:"Calming & herbal", k:"herbal"},
      {t:"Fresh & outdoorsy", k:"fresh"},
      {t:"Sweet & cozy", k:"sweet"},
    ]
  },
  {
    q:"What do you want most from your wash?",
    opts:[
      {t:"To wind down and relax", k:"relax"},
      {t:"A little everyday pampering", k:"pamper"},
      {t:"To wake up and feel fresh", k:"fresh"},
      {t:"Just clean and simple — no fuss", k:"simple"},
    ]
  },
  {
    q:"Last one — which sounds most like you?",
    opts:[
      {t:"Calm and grounded", k:"calm"},
      {t:"Warm and social", k:"social"},
      {t:"Adventurous and outdoorsy", k:"adventurous"},
      {t:"Dreamy and creative", k:"dreamy"},
      {t:"I like to keep things simple", k:"simple"},
    ]
  }
];

// 5 goats with target trait profiles (0-12 scale) + coat color + signature scent
const goats = [
  {n:"Sage",   r:"the Calm One",        c:"#c4b6df", scent:"Lavender & Oat",   e:1, s:5, a:1, si:1,  b:"Unbothered, grounded, quietly kind. You're the friend everyone exhales around — the steady center of the room."},
  {n:"Daisy",  r:"the Social Butterfly",c:"#e9cf85", scent:"Honey & Almond",   e:6, s:11,a:2, si:5,  b:"You know everyone's name and remember their birthday. Warm, bubbly, and the reason the group chat is still alive."},
  {n:"Atlas",  r:"the Adventurer",      c:"#7fa8c4", scent:"Cedar & Sea Salt",  e:9, s:2, a:11,si:2,  b:"Maps are suggestions. You're happiest outdoors, chasing the next ridge, the next trip, the next idea."},
  {n:"Willow", r:"the Dreamer",         c:"#f3c4d2", scent:"Rose & Vanilla",    e:3, s:2, a:5, si:2,  b:"Head in the clouds, heart in a notebook. Creative, a little introspective, and quietly making something beautiful."},
];


function goatSVG(color){
  return `<img class="goatart" src="${GOAT_IMG}" alt="Creamy Meadow goat" style="filter:drop-shadow(0 8px 12px rgba(40,71,90,.16));">`;
}

let qIndex = 0;
let answers = [];

function renderQuestion(){
  const box = document.getElementById('quizbox');
  const q = questions[qIndex];
  box.innerHTML = `
    <div class="progress"><div class="bar" style="width:${((qIndex+1)/questions.length)*100}%"></div></div>
    <div class="qcount">Question ${qIndex+1} of ${questions.length}</div>
    <div class="question qfade">${q.q}</div>
    <div class="options qfade">
      ${q.opts.map((o,i)=>`
        <button class="opt" onclick="choose(${i})">
          <span class="dot">${String.fromCharCode(65+i)}</span>${o.t}
        </button>`).join('')}
    </div>
    ${qIndex>0 ? '<button class="quizback" onclick="goBack()">\u2190 Back</button>' : ''}`;
}

function choose(i){
  answers[qIndex] = questions[qIndex].opts[i].k;
  qIndex++;
  if(qIndex < questions.length){
    renderQuestion();
  } else {
    showResult();
  }
}

function goBack(){
  if(qIndex > 0){
    qIndex--;
    answers.length = qIndex; // drop answers from here on so they're re-asked cleanly
    renderQuestion();
  }
}

function recommendSoap(ans){
  var skin=ans[0], flag=ans[1], vibe=ans[2], want=ans[3], you=ans[4];
  // Safety + explicit request: route straight to fragrance-free Original
  if(vibe==='unscented'){
    return {name:'Original', tag:'Your gentlest match',
      why:"Fragrance-free and beautifully simple — the kindest pick for skin that's easily upset, or when you'd just rather keep it clean and bare."};
  }
  // Otherwise: score every bar across all your answers and pick the best fit
  var score={Original:0, Sage:0, Daisy:0, Atlas:0, Willow:0};
  // skin
  if(skin==='dry'){       score.Daisy+=2; }
  if(skin==='sensitive'){ score.Sage+=2; score.Original+=1; }
  if(skin==='oily'){      score.Atlas+=2; }
  if(skin==='normal'){    score.Willow+=2; score.Daisy+=1; }
  // skin flags lean fragrance-free, but don't lock it
  if(flag==='reactive'){  score.Original+=2; }
  if(flag==='fragrance'){ score.Original+=2; }
  // scent vibe — the most decisive signal (matched to each bar's actual scent)
  if(vibe==='floral'){    score.Willow+=3; score.Daisy+=1; }   // Rose & Vanilla
  if(vibe==='herbal'){    score.Sage+=3; }                      // Lavender & Oat
  if(vibe==='fresh'){     score.Atlas+=3; }                     // Cedar & Sea Salt
  if(vibe==='sweet'){     score.Daisy+=2; score.Willow+=2; }    // Honey & Almond / Vanilla
  // what they want from the wash
  if(want==='relax'){     score.Sage+=3; }
  if(want==='pamper'){    score.Willow+=2; score.Daisy+=2; }
  if(want==='fresh'){     score.Atlas+=3; }
  if(want==='simple'){    score.Original+=2; }
  // personality
  if(you==='calm'){        score.Sage+=2; }
  if(you==='social'){      score.Daisy+=2; }
  if(you==='adventurous'){ score.Atlas+=2; }
  if(you==='dreamy'){      score.Willow+=2; }
  if(you==='simple'){      score.Original+=1; }
  var order=['Sage','Daisy','Atlas','Willow','Original'];
  var best=order[0];
  order.forEach(function(n){ if(score[n]>score[best]) best=n; });
  var whyMap={
    Sage:"Calming lavender & oat — a soothing, grounded everyday bar that matches your steady, laid-back streak.",
    Daisy:"Honey & almond — soft, lightly sweet and nourishing, just like your warm, people-loving side.",
    Atlas:"Cedar & sea salt — fresh, clean and a touch outdoorsy, for someone always chasing the next adventure.",
    Willow:"Rose & vanilla — cozy, dreamy and a little bit of pampering for your creative, head-in-the-clouds self.",
    Original:"Fragrance-free and wonderfully simple — no fuss, no extras, just gentle goat-milk soap."
  };
  return {name:best, tag:'Your perfect match', why:whyMap[best]};
}

var quizMatch = null;   // {name, tag, why} — set right after the quiz, drives the PDP "this is your soap" banner
function showResult(){
  var rec = recommendSoap(answers);
  var idx = 0;
  for(var i=0;i<SHOP.length;i++){ if(SHOP[i].n===rec.name){ idx=i; break; } }
  quizMatch = {name: rec.name, tag: rec.tag, why: rec.why};
  showProduct(idx);   // take them straight to their match
}

function restart(){
  qIndex=0; answers=[];
  renderQuestion();
}

function retakeQuiz(){
  quizMatch=null; qIndex=0; answers=[];
  renderQuestion();
  showPage('quiz');
}

// build the Our Goats page from the same goat data
var GOAT_PHOTO = {"Sage":CMIMG[48], "Daisy":CMIMG[49], "Atlas":CMIMG[50], "Willow":CMIMG[51]};
var GOAT_ART_BG = {"Sage":"#E9DFF3", "Daisy":"#FEEFDB", "Atlas":"#D3E0EF", "Willow":"#FCEAEB"};
var GOAT_TRAITS = [
  {label:'Social',      v:function(g){return g.s;},  invert:false},
  {label:'Adventurous', v:function(g){return g.a;},  invert:false},
  {label:'Calm',        v:function(g){return g.e;},  invert:true},
  {label:'Playful',     v:function(g){return g.si;}, invert:false}
];
function goatTraitStat(g, t){
  var raw = t.v(g);
  if(t.invert) raw = 11 - raw;            // calm = the inverse of energy
  return Math.max(1, Math.min(10, Math.round(raw)));
}
function renderGoats(){
  const grid = document.getElementById('goatGrid');
  grid.innerHTML = goats.map(function(g){
    var bars = GOAT_TRAITS.map(function(t){
      var st = goatTraitStat(g,t);
      return '<div class="gt-row"><span class="gt-label">'+t.label+'</span>'
           + '<span class="gt-track"><span class="gt-fill" style="width:'+(st*10)+'%;background:'+g.c+'"></span></span>'
           + '<span class="gt-num">'+st+'</span></div>';
    }).join('');
    return '<div class="goatcard">'
      + '<div class="art" style="background:'+(GOAT_ART_BG[g.n]||g.c+'33')+'">'+'<img class="goatphoto" src="'+(GOAT_PHOTO[g.n]||GOAT_IMG)+'" alt="'+g.n+', a Creamy Meadow goat" loading="lazy">'+'</div>'
      + '<h3>'+g.n+'</h3>'
      + '<div class="role">'+g.r+'</div>'
      + '<div class="scent"> '+g.scent+'</div>'
      + '<p>'+g.b+'</p>'
      + '<div class="goat-traits">'+bars+'</div>'
      + '</div>';
  }).join('');
}

// a soap-bar illustration tinted in a goat's coat colour (matches the morph bar)
function goatHead(stroke){
  return `<g stroke="${stroke}" stroke-width="3" fill="none" stroke-linecap="round" stroke-linejoin="round">
    <path d="M-12 -28 C-18 -42 -10 -52 4 -54"/>
    <path d="M6 -28 C2 -44 12 -54 26 -54"/>
    <path d="M-24 -12 C-42 -16 -50 -6 -44 6 C-38 14 -26 10 -20 2"/>
    <path d="M24 -12 C42 -16 50 -6 44 6 C38 14 26 10 20 2"/>
    <path d="M-20 -14 C-28 8 -22 34 2 42 C26 34 32 8 24 -14 C16 -28 -12 -28 -20 -14 Z"/>
    <circle cx="-9" cy="0" r="3" fill="${stroke}" stroke="none"/>
    <circle cx="11" cy="0" r="3" fill="${stroke}" stroke="none"/>
    <path d="M-5 18 C-1 22 5 22 9 18"/>
    <path d="M2 12 L2 18"/>
    <path d="M-2 42 C0 52 4 52 6 42"/>
  </g>`;
}
function barSVG(color){
  return `<svg viewBox="0 0 220 172" xmlns="http://www.w3.org/2000/svg">
    <defs><linearGradient id="barShine" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0" stop-color="#ffffff" stop-opacity=".55"/><stop offset=".55" stop-color="#ffffff" stop-opacity="0"/>
    </linearGradient></defs>
    <ellipse cx="110" cy="154" rx="84" ry="12" fill="#28475a" opacity=".12"/>
    <rect x="26" y="22" width="168" height="122" rx="30" fill="${color}" stroke="#28475a" stroke-width="3.5"/>
    <rect x="26" y="22" width="168" height="122" rx="30" fill="url(#barShine)"/>
    <image href="${STAMP_IMG}" x="63" y="29" width="94" height="104"/>
  </svg>`;
}

// ===== Product coverflow: index-based picker (no scroll dependency) =====
var PRODS = [
  {n:'Sage',    s:'Lavender & Oat',   c:'#c4b6df'},
  {n:'Daisy',   s:'Honey & Almond',   c:'#e9cf85'},
  {n:'Original', s:'Unscented',       c:'#f4ead2'},
  {n:'Atlas',   s:'Cedar & Sea Salt', c:'#7fa8c4'},
  {n:'Willow',  s:'Rose & Vanilla',   c:'#f3c4d2'},
];
var PCARD = 248;
var prodIndex = 2;        // start centered on Original (the middle bar)
var prodLocked = true;    // ride disabled: show the lineup in its docked spot, no scroll travel
function setProd(i){
  const row  = document.getElementById('prodRow');
  const dots = document.getElementById('prodDots');
  if(!row) return;
  const N = PRODS.length;
  prodIndex = ((i % N) + N) % N;   // wrap -> loops past either end
  if(!row.dataset.built){
    row.innerHTML = PRODS.map((p,k)=>
      '<div class="psoap-slide" onclick="openProd('+k+')"><div class="pbar" style="--c:'+p.c+'"><span class="pbar-goat"></span><span class="pbar-word">goat milk soap</span></div></div>'
    ).join('');
    row.dataset.built = '1';
  }
  const slides = row.children;
  for(let k=0;k<slides.length;k++) slides[k].classList.toggle('is-active', k===prodIndex);
  const vp = row.parentElement, slide = slides[prodIndex];
  if(slide && vp.clientWidth){                                   // center the active soap; neighbors peek on each side
    const off = slide.offsetLeft + slide.offsetWidth/2 - vp.clientWidth/2;
    row.style.transform = 'translateX(' + (-off) + 'px)';
  }
  if(dots) dots.innerHTML = PRODS.map((p,k)=>'<span class="'+(k===prodIndex?'on':'')+'" onclick="prodGo('+k+')"></span>').join('');
  const cap = document.getElementById('prodCap'), g = PRODS[prodIndex];
  if(cap && g) cap.innerHTML = '<b>'+g.n+'</b> · '+g.s;
}
function prodGo(i){ prodLocked = true; setProd(i); }
function prodStep(d){ prodLocked = true; setProd((prodIndex||0) + d); }
window.addEventListener('resize', function(){ setProd(prodIndex); });
function openProd(k){ var nm=(PRODS[k]||{}).n; for(var j=0;j<SHOP.length;j++){ if(SHOP[j].n===nm){ showProduct(j); return; } } }
(function(){
  const sec     = document.getElementById('prodSec');
  const track   = document.getElementById('prodTrack');
  const stage   = track && track.parentElement;
  const fly     = document.getElementById('flySoap');
  const heroBar = document.getElementById('heroBar');
  if(track){
    Array.from(track.children).forEach((card,k)=> card.addEventListener('click', ()=>{
      var nm = (PRODS[k] || {}).n;                       // home order ≠ shop order, so match by name
      for(var i=0; i<SHOP.length; i++){ if(SHOP[i].n === nm){ showProduct(i); return; } }
      prodLocked = true; setProd(k);                      // fallback: just center it
    }));
  }
  // CRO no-motion pass: keep the lineup visible and do not run the scroll-riding soap animation.
  setProd(prodIndex);
  if(sec) sec.classList.add('revealed');
  if(fly) fly.classList.remove('show');
  if(heroBar) heroBar.style.opacity = '1';
  window.__resetRide = function(){ prodLocked = true; prodIndex = 2; setProd(2); if(sec) sec.classList.add('revealed'); };
  return;
  function showHeroBar(on){ if(heroBar) heroBar.style.opacity = on ? '1' : '0'; }
  let ticking = false;
  function frame(){
    ticking = false;
    var homeEl = document.getElementById('page-home');
    if(homeEl && homeEl.style.display === 'none') return;   // only run the ride while Home is visible
    if(window.innerWidth <= 640){                            // phones: no ride, just show the lineup
      sec.classList.add('revealed');
      fly.classList.remove('show');
      showHeroBar(true);
      prodLocked = true;
      return;
    }
    // one-shot: once it has docked (or the user picked a soap), leave everything put
    if(prodLocked){
      sec.classList.add('revealed');
      fly.classList.remove('show');
      showHeroBar(true);
      return;
    }
    const sy = window.pageYOffset || document.documentElement.scrollTop || 0;
    const sRect = stage.getBoundingClientRect();
    const stageCY = sRect.top + sRect.height/2;     // stage center, viewport
    const stageCX = sRect.left + sRect.width/2;
    const dockY = window.innerHeight * 0.52;        // where the soap finishes its trip
    const stageDocCY = stageCY + sy;                // stage center in document coords (constant)
    const dockScroll = Math.max(1, stageDocCY - dockY); // scrollY at which it docks
    if(sy >= dockScroll){
      // DOCKED: real lineup shows, flyer gone — and lock so it never replays this load
      prodLocked = true;
      sec.classList.add('revealed');
      fly.classList.remove('show');
      showHeroBar(true);
    } else {
      // RIDING: the hero bar becomes the flyer (so there's only ever one soap)
      sec.classList.remove('revealed');
      showHeroBar(false);
      fly.classList.add('show');
      const p = Math.max(0, Math.min(1, sy / dockScroll));   // 0 at hero, 1 at dock
      let hx, hy;
      if(heroBar){
        const hRect = heroBar.getBoundingClientRect();
        hx = hRect.left + hRect.width/2;
        hy = hRect.top  + hRect.height/2;
      } else { hx = window.innerWidth*0.68; hy = window.innerHeight*0.34; }
      const fx = hx + (stageCX - hx) * p;            // glide from hero spot to stage center
      const fy = hy + (stageCY - hy) * p;
      const tilt = (-8 * (1 - p)).toFixed(2);        // starts leaning like the hero bar, straightens as it lands
      // move with transform only (GPU-composited) — no top/left writes, so scrolling doesn't trigger reflow
      fly.style.transform = 'translate(' + fx + 'px,' + fy + 'px) translate(-50%,-50%) rotate(' + tilt + 'deg)';
    }
  }
  function onScroll(){ if(!ticking){ ticking = true; requestAnimationFrame(frame); } }
  window.addEventListener('scroll', onScroll, {passive:true});
  window.addEventListener('resize', ()=>{ setProd(prodIndex||0); onScroll(); });
  frame();
  // let the intro ride replay whenever we land back on Home
  window.__resetRide = function(){ prodLocked = false; prodIndex = 2; setProd(2); frame(); };
})();




/* ===== SPECTRUM ROW SHOWCASE (real photos, SpoiledChild-style) ===== */
var SPEC2 = ['Sage','Daisy','Original','Atlas','Willow'];
var spec2Idx = 2;
function renderSpec2(){
  var row = document.getElementById('spec2Row');
  var nameEl = document.getElementById('spec2Name');
  if(!row) return;
  if(!row.dataset.built){
    row.innerHTML = SPEC2.map(function(n,k){
      var p=null; for(var i=0;i<SHOP.length;i++){ if(SHOP[i].n===n){p=SHOP[i];break;} }
      var img=(typeof PRODUCT_IMGS!=='undefined'&&PRODUCT_IMGS[n])?PRODUCT_IMGS[n]:'';
      return '<div class="spec2-item" onclick="openSpec2('+k+')" onmouseenter="featureSpec2('+k+')">'
           + '<span class="spec2-tip">'+(p?p.n+' \u00b7 '+p.s:n)+'</span>'
           + '<img src="'+img+'" alt="'+n+' goat milk soap bar" loading="lazy" decoding="async">'
           + '</div>';
    }).join('');
    row.dataset.built='1';
  }
  var items=row.children;
  for(var i=0;i<items.length;i++) items[i].classList.toggle('is-active', i===spec2Idx);
  var nm=SPEC2[spec2Idx], p=null;
  for(var j=0;j<SHOP.length;j++){ if(SHOP[j].n===nm){p=SHOP[j];break;} }
  if(nameEl&&p) nameEl.innerHTML='<b>'+p.n+'</b> \u00b7 '+p.s;
  var _a=items[spec2Idx];
  if(_a && row.scrollWidth > row.clientWidth+4){ row.scrollTo({left:_a.offsetLeft-(row.clientWidth-_a.offsetWidth)/2, behavior:'smooth'}); }
}
function featureSpec2(k){ spec2Idx=k; renderSpec2(); }
function spec2Go(i){ var N=SPEC2.length; spec2Idx=((i%N)+N)%N; renderSpec2(); }
function spec2Step(d){ spec2Go(spec2Idx+d); }
function openSpec2(k){ var nm=SPEC2[k]; for(var i=0;i<SHOP.length;i++){ if(SHOP[i].n===nm){ showProduct(i); return; } } }
renderSpec2();
window.addEventListener('resize', renderSpec2);

renderQuestion();
renderGoats();

/* ============ INGREDIENTS CAROUSEL ============ */
const ingredients = [
  {ic:'', n:'Goat milk',     d:'Creamy fats and gentle lactic acid that soften without stripping.'},
  {ic:'', n:'Colloidal oat', d:'Soothes itch and calms easily-irritated skin.'},
  {ic:'', n:'Olive oil',     d:'Rich in moisture to nourish and protect dry skin.'},
  {ic:'', n:'Coconut oil',   d:'A soft, conditioning lather that rinses clean.'},
  {ic:'', n:'Raw honey',     d:'Naturally calming and a magnet for moisture.'},
  {ic:'', n:'Shea butter',   d:'Buttery and deeply nourishing for tight, thirsty skin.'},
];
let ingIdx = Math.floor(ingredients.length / 2);
function renderIng(){
  const track = document.getElementById('ingTrack');
  const desc  = document.getElementById('ingDesc');
  if(!track) return;
  const ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10Z"/><path d="M2 21c0-3 1.85-5.36 5.08-6"/></svg>';
  if(!track.dataset.built){
    track.innerHTML = ingredients.map(function(g,i){
      return '<div class="ing2-item" onclick="ingGo('+i+')" onmouseenter="ingGo('+i+')">'
           + '<div class="ing2-chip">'+ICON+'</div>'
           + '<div class="ing2-label">'+g.n+'</div>'
           + '</div>';
    }).join('');
    track.dataset.built = '1';
  }
  const items = track.children;
  for(let i=0;i<items.length;i++) items[i].classList.toggle('is-active', i===ingIdx);
  const g = ingredients[ingIdx];
  if(desc && g) desc.innerHTML = '<b>'+g.n+'.</b> '+g.d;
  const _a = items[ingIdx];
  if(_a && track.scrollWidth > track.clientWidth+4){ track.scrollTo({left:_a.offsetLeft-(track.clientWidth-_a.offsetWidth)/2, behavior:'smooth'}); }
}
function ingGo(i){ ingIdx = (i + ingredients.length) % ingredients.length; renderIng(); }
function ingMove(d){ ingGo(ingIdx + d); }
window.addEventListener('resize', renderIng);
renderIng();

// fill the standing goat + the product label goats, and add Spoiled-Child-style float/tilt
(function(){
  const mGoat = document.getElementById('mgGoat');
  if(mGoat){ mGoat.innerHTML = goatSVG('#fffdf6'); var _stain=document.createElement('div'); _stain.className='mg-mouth'; _stain.id='mgMouth'; mGoat.appendChild(_stain); }
  const XL = 'http://www.w3.org/1999/xlink';
  const setImg = (el, src) => { if(!el) return; el.setAttribute('href', src); el.setAttributeNS(XL, 'xlink:href', src); };
  setImg(document.getElementById('boxGoat'), GOAT_IMG);
  setImg(document.getElementById('barGoat'), GOAT_IMG);
  setImg(document.getElementById('barStamp'), STAMP_IMG);
  // CRO no-motion pass: product images are filled above, but hero tilt/scroll animations are disabled.
  const tilt = document.getElementById('productTilt');
  if(tilt) tilt.style.transform = 'none';
})();

/* swap nav logo to the background-free goat cutout */
(function(){ var nl=document.querySelector('.nav-logo'); if(nl && typeof GOAT_IMG!=='undefined') nl.src=GOAT_IMG; })();

/* ============ REVIEWS (sliding marquee) ============ */
var REVIEWS = [
  {who:"Maya R.", text:"My skin felt noticeably softer after the first few washes. It cleaned well without leaving that tight, dry feeling."},
  {who:"Lauren T.", text:"I usually avoid bar soap because it dries out my skin, but this goat milk soap felt surprisingly gentle."},
  {who:"Jasmine C.", text:"The lather felt creamy and luxurious, and my skin felt smooth after rinsing."},
  {who:"Emily H.", text:"I loved how clean my skin felt without feeling stripped of moisture."},
  {who:"Brianna S.", text:"After adding this soap to my routine, my hands felt much less rough and dry."},
  {who:"Nicole W.", text:"This soap made my everyday shower feel more relaxing and special."},
  {who:"Alyssa M.", text:"The fragrance was soft and pleasant\u2014not overpowering like many store-bought soaps."},
  {who:"Hannah P.", text:"My skin normally feels tight after showering, but this bar left it feeling comfortable."},
  {who:"Kayla D.", text:"I was surprised by how rich the lather was. A little went a long way."},
  {who:"Rachel B.", text:"It felt gentle enough for daily use and left my skin feeling refreshed."},
  {who:"Samantha K.", text:"The Unscented bar was perfect for my simple skincare routine."},
  {who:"Olivia N.", text:"I appreciated the clean ingredients and the handmade feel of the soap."},
  {who:"Destiny F.", text:"My skin felt softer and smoother after using it consistently for a week."},
  {who:"Morgan J.", text:"This has become my favorite soap for washing my hands because it does not leave them feeling dry."},
  {who:"Chloe A.", text:"The Lavender scent made my nighttime shower feel calm and relaxing."},
  {who:"Vanessa L.", text:"I liked that the scent was noticeable without being too strong."},
  {who:"Madison G.", text:"The bar felt creamy on my skin and rinsed away easily."},
  {who:"Taylor R.", text:"It gave me a clean feeling without the harshness I usually experience with regular soap."},
  {who:"Gabrielle S.", text:"My skin looked and felt more moisturized after I started using this bar."},
  {who:"Ashley T.", text:"I bought it because I was curious about goat milk soap, and now I understand why people love it."},
  {who:"Sofia M.", text:"The Rose scent smelled soft, fresh, and elegant."},
  {who:"Danielle C.", text:"It felt like a small upgrade to my everyday shower routine."},
  {who:"Kendra H.", text:"I loved the natural, handmade appearance of the soap."},
  {who:"Erica W.", text:"My elbows and hands usually feel rough, but they felt much smoother after using this soap regularly."},
  {who:"Lily P.", text:"The soap produced a rich lather without needing to use a lot of the bar."},
  {who:"Brooke D.", text:"It left my skin feeling clean, soft, and comfortable."},
  {who:"Natalie B.", text:"I liked it so much that I started using it for both my hands and body."},
  {who:"Megan K.", text:"The packaging was adorable and made the soap feel perfect for gifting."},
  {who:"Ariana N.", text:"I enjoyed knowing that I was using a thoughtfully made product from a small business."},
  {who:"Courtney F.", text:"My skin felt less dry after showering compared with the body wash I used before."},
  {who:"Jada J.", text:"The scent made my bathroom smell fresh without being overwhelming."},
  {who:"Paige A.", text:"The bar lasted longer than I expected when I kept it dry between uses."},
  {who:"Autumn L.", text:"It felt gentle, creamy, and soothing during every wash."},
  {who:"Kiara G.", text:"The Daisy scent was light, cheerful, and perfect for everyday use."},
  {who:"Sydney R.", text:"I noticed that my hands did not feel as uncomfortable after frequent washing."},
  {who:"Maria S.", text:"This soap had the perfect balance of cleansing and moisturizing."},
  {who:"Faith T.", text:"My skin felt smooth immediately after rinsing and drying off."},
  {who:"Alexis M.", text:"I loved the wholesome ingredients and the simple formula."},
  {who:"Jordan C.", text:"The Atlas scent felt fresh and clean without smelling artificial."},
  {who:"Kelsey H.", text:"This is the kind of soap I would feel comfortable keeping in every bathroom."},
  {who:"Leah W.", text:"The Willow scent was subtle, refreshing, and easy to enjoy every day."},
  {who:"Camille P.", text:"I usually need lotion immediately after showering, but my skin felt much more comfortable after using this."},
  {who:"Rebekah D.", text:"The soap felt much gentler than the heavily fragranced bars I had used before."},
  {who:"Nina B.", text:"I loved the creamy texture and how easily the soap glided across my skin."},
  {who:"Jocelyn K.", text:"It made a noticeable difference in how soft my hands felt throughout the day."},
  {who:"Marissa N.", text:"The variety pack would make such a thoughtful and useful gift."},
  {who:"Chelsea F.", text:"I enjoyed trying the different scents and choosing one based on my mood."},
  {who:"Tiana J.", text:"It felt like a premium soap while still having a natural, handmade personality."},
  {who:"Melanie A.", text:"My whole family enjoyed using it, and the scent was gentle enough for everyone."},
  {who:"Isabella L.", text:"After trying goat milk soap, I did not want to return to my regular store-bought bar."}
];
var revIndex = 0;
function renderReviews(){
  var track = document.getElementById('revTrack'); if(!track) return;
  track.innerHTML = REVIEWS.map(function(r){
    return '<div class="rev">'
      + '<div class="rev-head"><div class="rev-avatar">🐐</div>'
        + '<div><div class="rev-who">'+r.who+'</div><div class="rev-tag">Verified buyer</div></div></div>'
      + '<div class="rev-goats">★★★★★</div>'
      + '<p>'+r.text+'</p>'
    + '</div>';
  }).join('');
  revIndex = 0;
  revApply();
}
function revMaxIndex(){
  var track = document.getElementById('revTrack'); if(!track || !track.children.length) return 0;
  var vp = track.parentElement;
  var step = track.children[0].getBoundingClientRect().width + 20;
  var visible = Math.max(1, Math.round(vp.getBoundingClientRect().width / step));
  return Math.max(0, track.children.length - visible);
}
function revApply(){
  var track = document.getElementById('revTrack'); if(!track || !track.children.length) return;
  var step = track.children[0].getBoundingClientRect().width + 20;
  revIndex = Math.min(revMaxIndex(), Math.max(0, revIndex));
  track.style.transform = 'translateX(' + (-revIndex * step) + 'px)';
  var prev = document.getElementById('revPrev'), next = document.getElementById('revNext');
  if(prev) prev.disabled = false;   // always active so the carousel can loop
  if(next) next.disabled = false;
}
function revMove(d){
  var maxI = revMaxIndex();
  revIndex += d;
  if(revIndex > maxI) revIndex = 0;        // past the end -> loop back to start
  else if(revIndex < 0) revIndex = maxI;   // before the start -> loop to the end
  revApply();
}
window.addEventListener('resize', revApply);
renderReviews();
/* pause CSS animations on sections that aren't on screen (saves CPU, smoother scroll) */
(function(){
  try{
    if(!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        en.target.style.animationPlayState = en.isIntersecting ? '' : 'paused';
        var kids = en.target.querySelectorAll('*');
        for(var k=0;k<kids.length;k++){ kids[k].style.animationPlayState = en.isIntersecting ? '' : 'paused'; }
      });
    }, { rootMargin: '120px' });
    var secs = document.querySelectorAll('header, section, .prod-sec, .transform-sec, .hero, .cm-marquee, [class*="-sec"]');
    for(var s=0;s<secs.length;s++){ io.observe(secs[s]); }
  }catch(e){}
})();
/* open the right product if the page loaded on a /products/{handle} URL, and handle back/forward */
(function(){
  function _cmInit(){ try{ cmRouteFromLocation(); }catch(e){} }
  if(document.readyState!=='loading'){ _cmInit(); } else { document.addEventListener('DOMContentLoaded', _cmInit); }
  window.addEventListener('popstate', function(){ try{ if(!cmRouteFromLocation()){ showPage('home'); } }catch(e){} });
})();

try{document.querySelectorAll("[data-cmimg]").forEach(function(e){var a=(e.tagName.toLowerCase()==="img")?"src":"href";e.setAttribute(a,CMIMG[e.getAttribute("data-cmimg")]);});}catch(e){}